module.exports = __webpack_public_path__ + "img/sec1.47abc02d.png";